import React, { useContext, useEffect } from 'react';
import SelectOption from '../../../models/SelectOption';
import { useTranslation } from 'react-i18next';
import { CustomCheckbox } from '../../Util/CustomCheckbox/CustomCheckbox';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchCTFiltersState } from '../../../redux/actions/filter';
import { CTFiltersEnum } from '../../../models/CTFilters';
import { CalledFrom } from '../../../models/CalledFromEnum';
import { getFilter } from '../../FilterV2/UtilFunctions';
import { TagFilterContext } from '../../../context/TagFilterContext';
import { setTagExcludeRegionals } from '../../Portfolio/Filter/HandleFiltersData/HandleFiltersData';

type Props = {
  indicatorCall?: boolean;
  calledFrom?: CalledFrom;
};

const ExcludeRegionalsFilter = (props: Props) => {
  const { indicatorCall, calledFrom } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const filter = useSelector<any, any>(state => getFilter(state, calledFrom));
  const { setTagOptions } = useContext(TagFilterContext);

  useEffect(() => {
    setTagOptions('excludeRegionals', setTagExcludeRegionals(filter.common));
  }, [filter.common.excludeRegionals, setTagOptions]);

  const handleSelectChange = (value: SelectOption, filterType: number) => {
    dispatch(dispatchCTFiltersState(filter, value, filterType, indicatorCall, calledFrom));
  };

  return (
    <CustomCheckbox
      labelText={t('exclude_regional')}
      isChecked={filter.common.excludeRegionals}
      handleOnClick={value => handleSelectChange(value, CTFiltersEnum.EXCLUDE_REGIONAL)}
      customStyle={{ marginBottom: 20 }}
    />
  );
};

export default ExcludeRegionalsFilter;
